// components/kyc/KycSuccessDialog.tsx
//
// Animated success dialog shown when KYC verification is approved

import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import { CheckCircle2 } from "lucide-react";
import { useMemo } from "react";
import { authLabels } from "@/i18n";
import { getLanguage } from "@/utils/languageUtils";

interface KycSuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const KycSuccessDialog = ({ isOpen, onClose }: KycSuccessDialogProps) => {
  const labels = useMemo(() => authLabels(getLanguage()), []);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[400px] border-none bg-transparent shadow-none">
        <div className="flex flex-col items-center justify-center py-12 space-y-6 bg-white dark:bg-gray-900 rounded-lg">
          <div className="relative">
            <CheckCircle2 className="h-24 w-24 text-green-500 animate-in zoom-in duration-500" />
            <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-30" />
            <div className="absolute inset-0 bg-green-500/20 rounded-full animate-pulse" />
          </div>
          <div className="text-center space-y-2 px-4">
            <p className="text-2xl font-bold text-green-600 dark:text-green-400 animate-in fade-in duration-500">
              {labels.kyc?.success?.title}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400 animate-in fade-in duration-700">
              {labels.kyc?.success?.description}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
